export default {
    title: "Erstelle Zahlungsläufe",
    generatePaymentRuns: "Erstellen",
    generatePreview: "Vorschau",
    bookingDate: "Buchungsdatum",
    bankAccount: "Bankverbindung",
    percentage: "Prozentsatz",
    intendedUse: "Verwendungszweck",
    intendedUsePlaceholders: "Du kannst im Verwendungszweck mehrere Platzhalter verwenden.",
    asPreview: "Nur Vorschau PDF erzeugen",
    comment: "Interner Kommentar",
    paymentRunsGenerated: "Zahlungsläufe wurden erstellt.",
    noValidPaymentRuns: "Die aktuelle Auswahl erzeugt keine gültigen Zahlungsläufe!",
    noBankAccountsToUse: "Es sind keine Bankkonten für die Zahlungsläufe verfügbar.",
    generatedRunsTitle: "Es entstehen folgende Zahlungsläufe",
    fromPayments: "kein Vorgang | Ein Vorgang | {count} Vorgänge",
    noOpenPaymentProcesses: "Es wurden Vorgänge gefunden, die keine offenen Zahlungen enthalten.",
    missingBankAccountProcesses: "Es wurden Vorgänge gefunden, bei denen keine Bankdaten hinterlegt sind.",
    noPartialPaidStatusTransitionPossibleProcesses: "Es wurden Vorgänge gefunden, die nicht von dir in einen teilweise bezahlten Status gesetzt werden dürfen.",
    noFullyPaidStatusTransitionPossibleProcesses: "Es wurden Vorgänge gefunden, die nicht von dir in einen vollständig bezahlten Status gesetzt werden dürfen.",
    errorOnCreation: "Es ist ein Fehler beim Erstellen der Zahlungsläufe aufgetreten.",
    noPaymentRunsCreated: "Es konnten keine Zahlungsläufe erstellt werden."
}